
import { Options, Vue } from 'vue-class-component'
import { Prop, Inject } from 'vue-property-decorator'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import KeyenceHTHardKeyButton from './KeyenceHTHardKeyButton.vue'

const HARDKEY_NUMBER_MAP: Record<number, KeyenceHardKey> = {
  1: KeyenceHardKey.NUM_1,
  2: KeyenceHardKey.NUM_2,
  3: KeyenceHardKey.NUM_3,
  4: KeyenceHardKey.NUM_4,
  5: KeyenceHardKey.NUM_5,
  6: KeyenceHardKey.NUM_6,
  7: KeyenceHardKey.NUM_7,
  8: KeyenceHardKey.NUM_8,
  9: KeyenceHardKey.NUM_9,
}

export interface HardKeyCounter {
  getNext(): number | null
  reset(): void
}

@Options({
  name: 'KeyenceHTHardKeySerialNumberButton',
  components: {
    KeyenceHTHardKeyButton,
  },
})
export default class KeyenceHTHardKeySerialNumberButton extends Vue {
  @Inject({ from: 'hardKeyCounter', default: null })
  private readonly hardKeyCounter?: HardKeyCounter | null

  @Prop({ type: Function, required: true })
  onPush!: () => void | Promise<void>

  @Prop({ type: Number, default: null })
  number!: number | null

  @Prop({ type: Boolean, default: true })
  preventDefault!: boolean

  @Prop({ type: Boolean, default: true })
  stopPropagation!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  private assignedNumber: number | null = null

  get assignedHardKey(): KeyenceHardKey | null {
    if (this.assignedNumber === null || this.assignedNumber < 1 || this.assignedNumber > 9) {
      return null
    }
    return HARDKEY_NUMBER_MAP[this.assignedNumber]
  }

  created(): void {
    if (this.number !== null && this.number >= 1 && this.number <= 9) {
      this.assignedNumber = this.number
      return
    }

    if (this.hardKeyCounter && typeof this.hardKeyCounter.getNext === 'function') {
      this.assignedNumber = this.hardKeyCounter.getNext()
    }
  }
}
